export default __webpack_public_path__ + "static/media/big02.ef5c951a.png";